const jobPath =
  /^\/generation-jobs\/[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i;
export const validOrganizationGenerationDetail = (path: string) => jobPath.test(path);
/** Only a literal local job path may survive login; no query, fragment, alternate origin or encoding. */
export function readOrganizationGenerationReturn(search: string): string | undefined {
  const params = new URLSearchParams(search);
  if (params.getAll("returnTo").length !== 1) return undefined;
  const path = params.get("returnTo");
  return path && validOrganizationGenerationDetail(path) ? path : undefined;
}
export function organizationGenerationLoginLink(path: string) {
  return validOrganizationGenerationDetail(path)
    ? `/login?${new URLSearchParams({ returnTo: path })}`
    : "/login";
}
